const swiper = new Swiper('.swiper', {
  // Optional parameters
  slidesPerView: 1,
  effect: 'slide',
  speed: 500,
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    900: {
      slidesPerView: 2,
      spaceBetween: 60
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});